/* eslint-disable no-unused-vars */
import React, { useCallback, useState, useEffect } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import globalColors from "../../../../../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import Loading from "../../../../../home/components/Loading";
import store from "../../../../../../store/store";
import { Grid, Container } from "@material-ui/core";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import { LawsuitDocumentTable } from "./LawsuitDocumentTable";
import { makeStyles } from "@material-ui/core/styles/";
import { faker } from '@faker-js/faker';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { SvgIcon } from "@material-ui/core";

export const LawsuitDocumentDataTable = (props) => {
  const useStyles = makeStyles(() => {
    return {
      root: {
        maxHeight: "fit-content",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: "75vh",
        borderRadius: "4px",
        boxShadow: `0 2px 4px rgba(0, 0, 0, 0.1)`
      },
      paper: {
        width: "100%",
        flex: "1",
      },
      table: {
        minWidth: 400,
        overflowX: "scroll",
        background: `${globalColors.backgroundColor8}40`,
      },
      tableWrapper: {
        overflow: "hidden !important",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        overflowX: "auto",
        borderRadius: "4px",
        boxShadow: props.removeShadow
          ? "none"
          : "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        border: "none",
      },
      tableContainer: {
        padding: "0 16px 0px 16px",
        marginTop: "5px",
      },
      search: {
        padding: 16,
      },
      input: {
        border: ".5px solid #707070",
        paddingRight: "10px",
        borderRadius: "4px",
        height: "48px",
        marginRight: "10px",
      },
      rows: {
        padding: "0 !important",
        margin: "0 !important",
      },
      addBtn: {
        padding: "16px 0",
        marginLeft: "16px",
      },
    };
  });
  const classes = useStyles();

  let api = AppAPIService.getInstance();
  const { auth } = store.getState();

  const userId = props?.userId;

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async (id) => {
    try {
      setLoading(true);
      await api.makeHttpRequest({
        method: "DELETE",
        url: `/lawsuit/${id}`,
      });

      setReload(!reload);
      setLoading(false);
      Swal.fire({
        title: "Sucesso!",
        text: "Documento deletado com sucesso.",
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao deletar documento.", "error");
    }

    setLoading(false);
  };
  const [expanded, setExpanded] = React.useState({});

  const handleSetSpanded = useCallback((id) => {
    setExpanded({ ...expanded, [id]: !expanded[id] })
  }, [expanded])

  const handleConfirmChangeStatus = async (obj) => {
    try {
      await api.makeHttpRequest({
        method: "PATCH",
        url: `/lawsuit/toggle/${obj.id}`,
        data: {
          active: !obj.active,
        },
      });

      setReload(!reload);

      const lawsuitStatus = !obj.active ? "ativado" : "desativado";

      Swal.fire({
        title: "Sucesso!",
        text: `Processo ${lawsuitStatus} com sucesso!`,
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (e) {
      Swal.fire("Erro!", "Erro ao alterar status.", "error");
    }
  };

  const [lawsuits, setLawsuits] = useState([]);

  const getLawsuitList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `/lawsuit/list-paginated?userId=${userId}`,
      });
      setLawsuits(response.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      Swal.fire("Erro!", "Erro ao carregar lista de processos.", "error");
    } finally {
      setLoading(false);
    }
  }, [api, userId]);

  useEffect(() => {
    getLawsuitList();
  }, [getLawsuitList, reload]);

  return (
    <>
      <Loading isLoading={loading} />
      <div
        style={{
          minHeight: "35vh",
          maxHeight: "fit-content",
          borderRadius: "4px",
          boxShadow: "0px 1px 1px 1px rgba(0,0,0,0.2)",
          display: "flex",
          padding: "20px 20px 20px 20px",
        }}
        className={`${classes.root}`}
        maxWidth="xxl"
      >
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            style={{
              width: "100%",
            }}
          >
            <LabelWithBackLine>Documentos do Processo</LabelWithBackLine>
            <Container
              maxWidth="xl"
              style={{
                padding: 0,
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            >
              {lawsuits.map((lawsuit) => {
                return (
                  <ExpansionPanel
                    onChange={() => {
                      handleSetSpanded({ ...expanded, [lawsuit.id]: !expanded[lawsuit.id] })
                      console.log(`expanded[${lawsuit.id}]`, expanded[lawsuit.id])
                    }}
                    style={{
                      marginBottom: "10px",
                    }}
                  >
                    <ExpansionPanelSummary
                      expandIcon={
                        expanded[lawsuit.id] ? <SvgIcon
                            component={ExpandLessIcon}
                            style={{
                              color: globalColors.colorWhite,
                              fontSize: "25px",
                            }}
                          />
                          : <SvgIcon
                            component={ExpandMoreIcon}
                            style={{
                              color: globalColors.colorWhite,
                              fontSize: "25px",
                            }}
                          />
                      }
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      style={{
                        backgroundColor: globalColors.primaryColor1,
                        color: globalColors.colorWhite,
                        width: "100%",
                        height: "30px",
                      }}
                    >

                      <Grid container md={12}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          color: globalColors.colorWhite,
                        }}
                      >
                        <Grid item md={3}>
                          <Typography>
                            <span>Processo: </span>
                            <span style={{
                              fontWeight: "bold",
                            }}>{lawsuit?.courtCaseNumber}</span>
                          </Typography>
                        </Grid>
                        <Grid item md={6}>
                          <Typography>
                            <span>Ação: </span>
                            <span style={{
                              fontWeight: "bold",
                            }}>{lawsuit?.action?.action}</span>
                          </Typography>
                        </Grid>
                        <Grid item md={3}>
                          <Typography>
                            <span>Valor do Processo: </span>
                            <span style={{
                              fontWeight: "bold",
                            }}>
                              {Number(lawsuit.value).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                              })}
                            </span>
                          </Typography>
                        </Grid>
                      </Grid>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                      style={{
                        padding: 0
                      }}
                    >
                      <LawsuitDocumentTable
                        reload={reload}
                        setReload={setReload}
                        lawsuitId={lawsuit.id}
                      />
                    </ExpansionPanelDetails>
                  </ExpansionPanel>

                );
              })}
            </Container>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(LawsuitDocumentDataTable);
